export default __webpack_public_path__ + "static/B0173-35d9e4328258c56d09953b5741e703d2.png";